import styled from 'styled-components';
import theme from 'shared/css/theme';

export const MultiSelectWrapper = styled.div`
  margin-right: 2rem; // Important to make space for the relative placed icon
  label {
    font-size: 1rem;
    line-height: 1.5rem;
    padding-bottom: 0.25rem;
  }
`;

export const ErrorTextStyled = styled.p`
  color: ${theme.colors.designSystem.dangerRed};
  font-size: 1rem;
  line-height: 1.5rem;
`;

export const ProgramFormElementWrapper = styled.div`
  width: 100%;
  padding-bottom: 2rem;
`;

export const IconWrapperStyled = styled.div`
  width: 0px;
  height: 0px;
  position: relative;
  left: 18.5rem;
  top: -2.25rem;
`;

export const stylesOverride = errors => ({
  option: (provided, state) => {
    const {
      selectProps: { useSecondaryColor } = {},
      isSelected = false,
      isFocused = false
    } = state || {};

    let borderColor = 'transparent';
    if (isSelected && useSecondaryColor) {
      borderColor = theme.colors.secondary.default;
    } else if (isSelected) {
      borderColor = theme.colors.primary.default;
    }

    let backgroundColor = 'transparent';
    if (isSelected && useSecondaryColor) {
      backgroundColor = theme.colors.secondary.lightest;
    } else if (isSelected) {
      backgroundColor = theme.colors.primary.lightest;
    } else if (isFocused) {
      backgroundColor = theme.colors.grey.lighter;
    }

    let hoverBackgroundColor = theme.colors.grey.lighter;
    if (isSelected && useSecondaryColor) {
      hoverBackgroundColor = theme.colors.secondary.lightest;
    } else if (isSelected) {
      hoverBackgroundColor = theme.colors.primary.lightest;
    }

    return {
      ...provided,
      borderLeft: `4px solid ${borderColor}`,
      backgroundColor,
      color: theme.colors.primary.darkest,
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),
      '&:active': {
        backgroundColor: 'transparent'
      },
      '&:hover': {
        backgroundColor: hoverBackgroundColor,
        cursor: 'pointer'
      }
    };
  },
  control: (provided, state) => {
    let backgroundColor = theme.colors.white;
    if (state.isDisabled) {
      backgroundColor = theme.inputs.item.disabled.backgroundColor;
    }

    let focusWithinStyles = {
      border: `1px solid ${theme.colors.designSystem.acuityBlue}`,
      outline: `2px solid ${theme.colors.white} !important`,
      boxShadow: `0 0 0 4px ${theme.colors.designSystem.acuityBlue}`
    };
    if (errors?.programs) {
      focusWithinStyles = {
        border: `1px solid ${theme.colors.designSystem.dangerRed}`,
        outline: `2px solid ${theme.colors.white} !important`,
        boxShadow: `0 0 0 4px ${theme.colors.designSystem.dangerRedDark}`
      };
    }

    return {
      ...provided,
      backgroundColor,
      border: `1px solid ${theme.colors.designSystem.neutral}`,
      fontSize: '1rem',
      height: theme.spacing(5),
      margin: `${theme.spacing(0.5)} 0`,
      minHeight: theme.spacing(5),
      '&:focus-within': focusWithinStyles,
      '&:hover': {
        cursor: 'pointer'
      }
    };
  },
  placeholder: provided => ({
    ...provided,
    color: theme.colors.grey.dark
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  menuList: provided => ({
    ...provided,
    padding: '0',
    maxHeight: `12rem`,
    overflowX: 'hidden',
    overflowY: 'auto'
  }),
  menu: provided => ({
    ...provided,
    borderRadius: '0px',
    filter: 'drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.15))'
  })
});
